import { Radios } from "../Radios";

export class RadiosFactory {
    public static create<TOption>(): new () => Radios<TOption> {
        type customRadiosCst = new () => Radios<TOption>;
        const instance = (Radios as any) as customRadiosCst;

        return instance;
    }
}
